import ModalDeleteFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeleteWorkingCenterUserProps extends ModalEditComponentProps { }

const ModalDeleteWorkingCenterUser: React.FC<ModalDeleteWorkingCenterUserProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()

    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/workingCenter/workingCenterUser/updateUserInner',
        data: {
            id: allRowData?.id,
            WorkingCenterId: null
        }
    })
    let translations = {
        title: t('sureDeassignWorkingCenterUser', '¿Seguro quieres desasignar este usuario del centro de trabajo?'),
        subtitle: t('onceDesasignedCouldBeRecovered', 'Una vez desasignado se podrá asignar de nuevo'),
        buttonAccept: t('desasign', 'Desasignar')
    }
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={translations} />
    )
}

export default ModalDeleteWorkingCenterUser